<template>
  <div class="view-tools-partners">
    <h5 class="text-semibold mb-5">Central de colaboradores</h5>
    <b-tabs content-class="mt-6" class="my-6">
      <b-tab title="Perfis de colaborador" active>
        <profiles />
      </b-tab>

      <b-tab title="Convites enviados">
        <invites-sent />
      </b-tab>

      <b-tab title="Meus Colaboradores">
        <partners />
      </b-tab>

      <b-tab title="Centrais que participo">
        <my-collabs />
      </b-tab>
      <b-tab title="Convite recebidos">
        <invites-received />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import InvitesReceived from "@/components/tools/partners/InvitesReceived.vue";
import InvitesSent from "@/components/tools/partners/InvitesSent.vue";
import MyCollabs from "@/components/tools/partners/MyCollabs";
import Partners from "@/components/tools/partners/Partners";
import Profiles from "@/components/tools/partners/Profiles";

export default {
  components: {
    Profiles,
    Partners,
    MyCollabs,
    InvitesSent,
    InvitesReceived
  }
};
</script>
